import { SELECT_LOCALE } from './';
import { setLanguage } from '../utils/api';

export default function selectLocale(locale) {
  return async dispatch => {
    await setLanguage(locale);
    dispatch({ type: SELECT_LOCALE, locale });
  };
}
